import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { PassengerType, PassengerTypeKey } from '../PassengerInfo/types';
import moment from 'moment';
import { IHolidayPassenger } from '../HolidayCheckout/types';
import _ from 'lodash';
interface IDialogDetailPassengerProps {
  passenger: IHolidayPassenger;
  isShow: boolean;
  onCloseDialog: () => void;
  dataPassenger: IHolidayPassenger[];
  countryOptions?: any[];
}

const DialogDetailPassenger: React.FC<IDialogDetailPassengerProps> = props => {
  const { passenger, dataPassenger, isShow, onCloseDialog, countryOptions } =
    props;
  const translations = useSelector(selectTranslations);
  const namePassenger = `${passenger.title} ${passenger.lastName}/${passenger.firstName}`;
  const passengerType = {
    [`${PassengerType.ADULT}`]: translations?.['b2b.txt.adult'],
    [`${PassengerType.CHILD}`]: translations?.['b2b.txt.child'],
    [`${PassengerType.INFANT}`]: translations?.['b2b.txt.infant'],
    [`${PassengerTypeKey.ADULT}`]: translations?.['b2b.txt.adult'],
    [`${PassengerTypeKey.CHILD}`]: translations?.['b2b.txt.child'],
    [`${PassengerTypeKey.INFANT}`]: translations?.['b2b.txt.infant'],
  };
  const documentType = {
    P: 'PASSPORT',
    I: 'CCCD',
  };
  const object = passenger?.passengerType
    ? passengerType[passenger?.passengerType]
    : '';
  const getGuardian = (id: string | number) => {
    const passenger = dataPassenger?.find(
      el => String(el.paxId) === String(id),
    );
    if (_.isEmpty(passenger)) {
      return '-';
    }
    const name = `${passenger.title} ${passenger.lastName}/${passenger.firstName}`;
    return name;
  };
  const formatCountry = (code: string) => {
    if (!code) return '';
    const country = countryOptions?.find((item: any) => item.value === code);
    return country ? country.label : '';
  };
  const formatIssuePlace = (place: string) => {
    if (!place) return '';
    const country = countryOptions?.find((item: any) => item.value === place);
    return country ? country.label : '';
  };
  return (
    <ModalContainer
      isShow={isShow}
      onCloseDialog={onCloseDialog}
      maskClosable={false}
      modalPadding="16px 24px 32px"
      modalHeight="initial"
      styleSlots={{
        iconWrapperStyle: {
          margin: '0 16px 0 0',
        },
        modalContentStyle: {
          maxWidth: 980,
          width: '96vw',
          maxHeight: '96vh',
        },
        modalBodyStyle: {
          height: 'fit-content',
        },
      }}
      modalProps={{ destroyOnClose: true }}
      CloseIcon={<CloseIcon width={12} height={12} />}
    >
      <TitleModel>
        {translations?.['b2b.txt.passengerDetails'] || ''}
      </TitleModel>
      <Line />
      <Container>
        <Row>
          <Label>{translations?.['b2b.txt.passengerName']}</Label>
          <Value>{namePassenger}</Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.txt.passengerType']}</Label>
          <Value>{object}</Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.form.birth']}</Label>
          <Value>
            {passenger.dateOfBirth
              ? moment(passenger.dateOfBirth).format('DD/MM/YYYY')
              : ''}
          </Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.txt.documentType']}</Label>
          <Value>
            {passenger?.document?.type
              ? documentType[passenger?.document?.type]
              : ''}
          </Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.txt.documentNumber']}</Label>
          <Value>{passenger?.document?.number || ''}</Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.form.national']}</Label>
          <Value>{formatCountry(passenger?.document?.nationality || '')}</Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.txt.issuePlace']}</Label>
          <Value>{formatIssuePlace(passenger?.document?.country || '')}</Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.txt.expiryDate']}</Label>
          <Value>
            {passenger?.document?.expiryDate
              ? moment(passenger?.document?.expiryDate).format('DD/MM/YYYY')
              : ''}
          </Value>
        </Row>
        <Row>
          <Label>{translations?.['b2b.form.gender']}</Label>
          <Value>
            {passenger?.document?.gender === 'M'
              ? translations?.['b2c.gender.male']
              : passenger?.document?.gender === 'F'
              ? translations?.['b2c.gender.female']
              : ''}
          </Value>
        </Row>
        {passenger.passengerType === 'INF' ||
          (passenger.passengerType === 'INFANT' && (
            <Row>
              <Label>{translations?.['b2b.txt.guardian']}</Label>
              <Value>
                {passenger.parentId ? getGuardian(passenger.parentId) : ''}
              </Value>
            </Row>
          ))}
      </Container>
    </ModalContainer>
  );
};
export default DialogDetailPassenger;
const TitleModel = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
const Line = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 16px -24px;
`;
const Container = styled.div`
  width: 100%;
  max-width: 520px;
  background: #fff;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 8px 0;
`;

const Label = styled.div`
  font-size: 14px;
  color: #8c8c8c;
`;

const Value = styled.div`
  font-size: 14px;
  color: #1f1f1f;
  font-weight: 500;
`;
